import { regEx } from 'utils'

export default (str) => regEx.email.test(String(str).toLocaleLowerCase())
